<template>
  <div>
    <sectionHeading text/>
    <div id="footerSection">
      <div id="footerMenuContainer">
        <ul class="footerMenu">
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Home</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Contact</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Feedback Profile</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Programs</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">LMNC</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Our Vision Gallery</a>
          </li>
        </ul>
        <ul class="footerMenu">
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Home</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Contact</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Feedback Profile</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Programs</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">LMNC</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Our Vision Gallery</a>
          </li>
        </ul>
        <ul class="footerMenu">
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Home</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Contact</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Feedback Profile</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Programs</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">LMNC</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Our Vision Gallery</a>
          </li>
        </ul>
      </div>
      <div id="footerLinks">
        <ul>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Home</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Contact</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Feedback Profile</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Programs</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">LMNC</a>
          </li>
          <li>
            <a href="http://" target="_blank" rel="noopener noreferrer">Our Vision Gallery</a>
          </li>
        </ul>
      </div>
      <div id="footerTexts">Inked By Ninetysix</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerSection"
};
</script>

<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: underline;
  }
}
#footerSection {
  display: flex;
  flex-direction: column;
  color: $color1;
  width: 100%;
}
#footerMenuContainer {
  display: flex;
  flex-direction: column;
  @include media-md {
    flex-direction: row;
  }
  justify-content: space-around;
  margin: 1.5rem 0;
  .footerMenu {
    margin: 10px;
    list-style: none;
  }
}
#footerLinks {
  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    list-style: none;
    color: $black;
    li {
      margin: 4px;
      @include media-md {
        margin: 10px;
      }
    }
  }
}
#footerTexts,
#footerLinks {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0.8rem 0;
  margin-top: 0;
  font-size: 0.9rem;
}
</style>

